import React from 'react';
import Countries from '../components/Countries';
import Filtering from '../components/Filtering'

const Home = () => {
    return (
        <>
            <Filtering/>
            <Countries/>
        </>
    )
}

export default Home
